import React from "react";

export default function PageNotFound() {
  let style = {
    display: "flex",
    height: "80vh",
    width: "100vw",
    alignItems: "center",
    justifyContent: "center",
  };
  return (
    <div style={style}>
      <h1>Page Not Found</h1>
    </div>
  );
}
